import { MessageOutlined } from "@ant-design/icons";
import React, { useState, useRef, useEffect } from "react";
import { useInterval, useLockFn } from "ahooks";
import general from "../../general";
import useActiveState from "../../lib/useActiveState";
import { prod } from "../../config";
import Dialog from "../../lib/Dialog";
import { CSSTransition } from "react-transition-group";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";

// 交易、回收小号时  输入手机号
export default (props) => {
  const [user] = useActiveState("user");

  const [code, setCode] = useState("");
  const [ing, setIng] = useState();
  const [time, setTime] = useState(0);
  const [mobile, setMobile] = useState(!prod ? "13227737527" : "");
  const inputRef = useRef(null);
  const codeArray = code.split("").slice(0, 6);

  // 当弹窗显示时自动聚焦
  useEffect(() => {
    if (props.show) {
      setCode("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
    }
  }, [props.show]);

  useInterval(() => {
    if (time) {
      setTime(time - 1);
    }
  }, 1000);

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value)
    );

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    return md5Hash;
  };

  const get = useLockFn(async () => {
    if (ing || time) {
      return;
    }
    setIng(true);
    Dialog.loading();

    let str = `${props.type}1${dayjs().unix().toString()}`;
    await general.axios
      .post("/v3/base/tool/getVerifyCode", {
        code: "code",
        type: props.type,
        mobile: "1",
        time: dayjs().unix().toString(),
        sign: encodeAndHash(str),
      })
      .finally(() => {
        setIng(false);
        Dialog.close();
      })
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setTime(60);
          setMobile(data.mobile);
          if (!prod) {
            setCode(data.verify_code || "");
          }
          // 聚焦到输入框
          setTimeout(() => {
            inputRef.current?.focus();
          }, 100);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });
  const verify = useLockFn(async () => {
    if (!code) {
      Dialog.error("请输入验证码");
      return;
    }
    Dialog.loading();
    await general.axios
      .post("/v3/base/tool/checkPhoneCode", { code, mobile })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let { status } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        props.close && props.close();
        props.onSuccess && props.onSuccess();
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });

  return (
    <CSSTransition
      in={props.show}
      timeout={250}
      appear={true}
      unmountOnExit={true}
    >
      <div className="user-phone-verify">
        <div className="entity">
          <div className="container">
            <div className="body">
              <div className="head">
                <div className="title">请输入验证码</div>
                <img
                  style={{ width: "20px", height: "20px" }}
                  src="/resources/four-three/trade/phone-close.png"
                  alt=""
                  onClick={() => props.close && props.close()}
                />
              </div>

              <div className="desc">
                <span>向{user.mobile}发送验证码？</span>
                <div
                  className={"btn" + (ing || time ? " disable" : "")}
                  onClick={get}
                >
                  {ing ? "发送中" : time ? time + "秒后重试" : "立即发送"}
                </div>
              </div>

              <div className="input">
                <input
                  ref={inputRef}
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={code}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setCode(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      e.preventDefault();
                      if (code.length > 0) {
                        setCode(code.slice(0, -1));
                      }
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedData = e.clipboardData
                      .getData("text")
                      .replace(/\D/g, "")
                      .slice(0, 6);
                    setCode(pastedData);
                  }}
                  style={{
                    position: "absolute",
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    pointerEvents: "auto",
                  }}
                />
                <div className="code-boxes">
                  {[0, 1, 2, 3, 4, 5].map((index) => (
                    <div
                      key={index}
                      className={`code-box ${
                        code.length === index ? "active" : ""
                      } ${codeArray[index] ? "filled" : ""}`}
                      onClick={() => inputRef.current?.focus()}
                    >
                      {codeArray[index] || ""}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="submit" onClick={verify}>
              确定
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};
